module.exports = __webpack_public_path__ + "img/file-type-movie.ba4786ed.svg";